<script lang="ts" setup>
    import HumanTime from '@shared/utils/HumanTime/HumanTime';
    import { JourneyStatus } from '@journeys/Enums';
    import { type Journey } from '@journeys/journeys.d';

    const props = defineProps<{
        journey: Journey;
    }>();

    const toHumanTime = new HumanTime({ locale: 'sv' });
</script>

<template>
    <p class="item-meta d-flex flex-wrap gap-lg m-sm-t">
        <span class="d-flex gap-xs">
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px">
                <path
                    d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
            </svg>
            <span>
                {{ $Resources.LastModifiedLabel }}
                <time :datetime="props.journey.LastModified">{{ toHumanTime.parse(props.journey.LastModified) }}</time>
                {{ $Resources.GenericByLabel }}
                {{ props.journey.LastModifiedBy.Name }}
            </span>
        </span>

        <span v-if="props.journey.Published" class="d-flex gap-xs">
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px">
                <path
                    d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-7-.5-14.5T799-507q-5 29-27 48t-52 19h-80q-33 0-56.5-23.5T560-520v-40H400v-80q0-33 23.5-56.5T480-720h40q0-23 12.5-40.5T563-789q-20-5-40.5-8t-42.5-3q-134 0-227 93t-93 227h200q66 0 113 47t47 113v40H400v110q20 5 39.5 7.5T480-160Z" />
            </svg>
            <span>
                {{ $Resources.PublishedLabel }}
                <time :datetime="props.journey.Published">{{ toHumanTime.parse(props.journey.Published) }}</time>
                {{ $Resources.GenericByLabel }}
                {{ props.journey.PublishedBy?.Name }}
            </span>
        </span>

        <span v-if="props.journey.EndedDate && props.journey.Status !== JourneyStatus.Active" class="d-flex gap-xs">
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px">
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
            </svg>
            <span>
                {{ $Resources.EndedLabel }}
                <time :datetime="props.journey.EndedDate">{{ toHumanTime.parse(props.journey.EndedDate) }}</time>
                {{ $Resources.GenericByLabel }}
                {{ props.journey.EndedBy?.Name }}
            </span>
        </span>
    </p>
</template>

<style>
    .item-meta > span {
        opacity: 0.85;
        font-size: small;
    }

    .item-meta svg {
        position: relative;
        top: 2px;
    }

    .items-list-cards .item-meta {
        gap: var(--ug-spacing-xs);
        flex-direction: column;
    }
</style>
